import noresult from "./noresult.svg";

export default function NoResultsIcon() {
  return (
    <img src={noresult} />
  );
}